import {Skeleton as RsnSkeleton} from '@raison/ui-kit';
import {color} from '@raison/ui-kit/theme';
import React from 'react';
import {Link} from 'react-router';
import {TariffName} from './types';

type Props = {
    tariff: TariffName;
    linkTo: string;
};

export function TariffMenuBanner({tariff, linkTo}: Props) {
    const [_, background] = colorMap[tariff];
    return (
        <Link to={linkTo} style={{background}} className={'flex flex-col gap-10 rounded-lg p-4'}>
            <TariffIcon tariff={tariff} />
            <div className={'flex flex-col gap-1'}>
                <div className={'fv-text-m-regular text-neutral-60'}>Your current plan</div>
                <div className={'fv-heading-s text-neutral-100'}>{tariff}</div>
            </div>
        </Link>
    );
}

export namespace TariffMenuBanner {
    export const Skeleton = () => <RsnSkeleton height={148} borderRadius={16} />;
}

function TariffIcon(props: {tariff: TariffName}) {
    const [mainColor, surfaceColor] = colorMap[props.tariff];
    return (
        <svg xmlns='http://www.w3.org/2000/svg' width='36' height='36' viewBox='0 0 36 36' fill='none'>
            <path
                fill={surfaceColor}
                fillRule='evenodd'
                d='M18 36c9.941 0 18-8.059 18-18S27.941 0 18 0 0 8.059 0 18s8.059 18 18 18'
                clipRule='evenodd'
            />
            <path fill={mainColor} d='M18.833 16.333h5.834l-7.5 10.834v-7.5h-5.834l7.5-10.834z' />
        </svg>
    );
}

const colorMap: Record<TariffName, [string, string]> = {
    Launch: [color.primary30, color.primary10],
    Growth: [color.success30, color.success10],
    Wealth: [color.gold30, color.gold10],
};
